/**
 * MembershipTemplatesAdmin.tsx — Admin > Memberships > Memberships.
 *
 * The corporate dashboard's Memberships page for the signed-in account:
 * membership templates with their products, procedures, agreement and
 * cancellation policy. See components/admin/MembershipTemplateAdmin.
 */
import { MembershipTemplateAdmin } from '@/components/admin/MembershipTemplateAdmin';

export function MembershipTemplatesAdmin() {
  return <MembershipTemplateAdmin kind="membership" />;
}
